import { format } from 'date-fns';

export default {
  methods: {
    formatDate(date, formatStr = 'dd MMMM yyyy') {
      return format(new Date(date), formatStr);
    },
  },
};
